import React from 'react';
import { TextField } from '@mui/material';

export interface GameDateTimePickerProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  'data-testid'?: string;
}

export const GameDateTimePicker: React.FC<GameDateTimePickerProps> = ({
  value,
  onChange,
  label = 'Game Date',
  required = false,
  fullWidth = true,
  size = 'medium',
  error,
  helperText,
  disabled = false,
  'data-testid': dataTestId = 'game-date-input',
}) => {
  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      type="datetime-local"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputLabelProps={{ shrink: true }}
      required={required}
      size={size}
      error={error}
      helperText={helperText}
      disabled={disabled}
      inputProps={{ 'data-testid': dataTestId }}
    />
  );
};
